import fetch from "@/fetch";
// 查询结果
export const getIconList = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/icon/select",
    data: params
  });
};

export const checkParam = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/user/check_user_login",
    data: params
  });
};

export const saveFavorite = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/icon/save_favorite",
    data: params
  });
};

export const getUserParm = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/user/getEncryptedUserInfo",
    data: params
  });
}

export const setClickRecord = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/icon/clickRecord",
    data: params
  });
}